import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const quizById: ApiFunc<`${typeof API.QUIZ}{id}`, 'get'> = data =>
  instance.get(`${API.QUIZ}${'id' in data ? data.id : data.name}`)

export const quizCreate: ApiFunc<`${typeof API.QUIZ}`, 'post'> = data => instance.post(API.QUIZ, data)

export const quizDelete: ApiFunc<`${typeof API.QUIZ}{id}`, 'delete'> = data =>
  instance.delete(`${API.QUIZ}${'id' in data ? data.id : data.name}`)

export const quizAll: ApiFunc<`${typeof API.QUIZ_ALL}`, 'get'> = data => instance.get(API.QUIZ_ALL, { params: data })

export const quizList: ApiFunc<`${typeof API.QUIZ}`, 'get'> = data => instance.get(API.QUIZ, { params: data })

export const quizPublish: ApiFunc<`${typeof API.QUIZ_PUBLISH}`, 'post'> = data => instance.post(API.QUIZ_PUBLISH, data)

export const quizCacheById: ApiFunc<`${typeof API.QUIZ_CACHE}{id}`, 'get'> = data =>
  instance.get(`${API.QUIZ_CACHE}${'id' in data ? data.id : data.name}`)

export const quizCacheAll: ApiFunc<`${typeof API.QUIZ_CACHE_ALL}`, 'get'> = data =>
  instance.get(API.QUIZ_CACHE_ALL, { params: data })

// export const quizResetOpen: ApiFunc<`${typeof API.QUIZ_RESET_OPEN}`, 'get'> = data =>
//   instance.get(API.QUIZ_RESET_OPEN, { params: data })

// export const quizResetOpenAll: ApiFunc<`${typeof API.QUIZ_RESET_OPEN_ALL}`, 'get'> = data =>
//   instance.get(API.QUIZ_RESET_OPEN_ALL, { params: data })

// export const quizResultOpen: ApiFunc<`${typeof API.QUIZ_RESULT_OPEN}`, 'get'> = data =>
//   instance.get(API.QUIZ_RESULT_OPEN, { params: data })

// export const quizResults: ApiFunc<`${typeof API.QUIZ_RESULTS}`, 'get'> = data =>
//   instance.get(API.QUIZ_RESULTS, { params: data })

export const quizResult: ApiFunc<`${typeof API.QUIZ_RESULT}{id}`, 'get'> = data =>
  instance.get(`${API.QUIZ_RESULT}${'id' in data ? data.id : data.name}`)

export const quizTypes: ApiFunc<`${typeof API.QUIZ_TYPES}`, 'get'> = data =>
  instance.get(API.QUIZ_TYPES, { params: data })
